module.exports = "build/assets/iceberg1.b49d9e52.png";